import { authApi } from 'api/auth/AuthApi';
import { borrowerApi } from 'api/BorrowerApi';

import { getAccountThunk } from './Auth/getAccount';
import { loginThunk } from './Auth/login';
import { logoutThunk } from './Auth/logout';
import { updateBorrowerThunk } from './Borrowers/updateBorrower';
import { getBorrowerByTokenThunk } from './Borrowers/getBorrowerByToken';

export const login = loginThunk(authApi);
export const logout = logoutThunk(authApi);
export const updateBorrower = updateBorrowerThunk(borrowerApi);

export const getAccount = getAccountThunk(authApi);
export const getBorrowerByToken = getBorrowerByTokenThunk(borrowerApi);
